<template>
    <!-- Wallet Card -->
    <div class="section pt-1">
        <div class="wallet-card">
            <!-- Balance -->
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">ടാർഗറ്റ്</span>
                    <h1 class="total text-primary">₹{{ target?target.toFixed(2):'0.00' }}</h1>
                </div>
                <div class="right" v-if="showAddButton">
                    <a href="javascript:void(0);" class="button" @click="adminAdd">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="section">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">കിട്ടിയത്</div>
                    <div class="value text-success">₹{{ total.toFixed(2) }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ബാക്കിയുള്ളത്</div>
                    <div class="value text-danger">₹{{ minusToZero ? minusToZero : '00.0' }}</div>
                </div>
            </div>
            <template v-if="user_level < 3">
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">സ്റ്റേറ്റ് വിഹിതം</div>
                        <div class="value text-warning">₹{{ getPercentage(target?target:0,total,1) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">ശാഖാ വിഹിതം</div>
                        <div class="value text-info">₹{{ getPercentage(target?target:0,total,4) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">മണ്ഡലം വിഹിതം</div>
                        <div class="value text-secondary">₹{{ getPercentage(target?target:0,total,3) }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text">ജില്ല വിഹിതം</div>
                        <div class="value text-primary">₹{{ getPercentage(target?target:0,total,2) }}</div>
                    </div>
                </div>
            </template>
            <template v-if="is_youth_dawa_fund">
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text" style="font-size:11px;">കാണേണ്ടവരുടെ എണ്ണം</div>
                        <div class="value text-dark">{{ toMeetCount }}</div>
                    </div>
                </div>
                <div class="col-6 mt-1">
                    <div class="stat-box">
                        <div class="title mal-text" style="font-size:11px;">കണ്ടവരുടെ എണ്ണം</div>
                        <div class="value text-success">{{ metCount }}</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
    <!-- Collection consolidation (Youth Dawa Fund) -->
    <div class="section mt-1 mb-1" v-if="is_youth_dawa_fund && breakdown">
        <div class="consolidation-card">
            <div class="cons-header" @click="consOpen = !consOpen">
                <span class="cons-title">Consolidation Report</span>
                <ion-icon name="chevron-down-outline" class="cons-chevron" :class="{ open: consOpen }"></ion-icon>
            </div>
            <transition name="cons-collapse">
                <div v-show="consOpen" class="cons-body">
                    <div class="cons-row">
                        <span class="cons-label mal-text"><ion-icon name="wallet-outline" style="color:#1a418c;"></ion-icon> യൂണിറ്റിന്റെ കൈവശം</span>
                        <span class="cons-val">₹{{ formatAmt(breakdown.with_unit) }}</span>
                    </div>
                    <div class="cons-row">
                        <span class="cons-label mal-text"><ion-icon name="globe-outline" style="color:#16a34a;"></ion-icon> ഓൺലൈൻ പേയ്മെന്റ്</span>
                        <span class="cons-val">₹{{ formatAmt(breakdown.online) }}</span>
                    </div>
                    <div class="cons-row">
                        <span class="cons-label mal-text"><ion-icon name="business-outline" style="color:#b45309;"></ion-icon> QR / ഓഫീസ് (വെരിഫൈഡ്)</span>
                        <span class="cons-val">₹{{ formatAmt(breakdown.office) }}</span>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <!-- Help Desk -->
    <div class="section mt-1 mb-2">
        <help-desk-card />
    </div>

    <!-- Visit counts modal -->
    <div class="modal fade action-sheet" id="visitCountsModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ visitModalType === 'to_meet' ? 'കാണേണ്ടവർ' : 'കണ്ടവർ' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div v-if="visitModalList.length === 0" class="text-center py-3 mal-text">ആരും ഇല്ല</div>
                        <ul style="list-style:none; margin:0; padding:0;">
                            <li v-for="(item, idx) in visitModalList" :key="idx"
                                style="display:flex; align-items:center; padding:10px 12px; border-bottom:1px solid #f0f0f0;">
                                <span style="font-size:13px; color:#aaa; width:24px; flex-shrink:0;">{{ idx + 1 }}</span>
                                <div style="flex:1; min-width:0;">
                                    <div style="font-weight:600;">{{ item.name || '—' }}</div>
                                    <div style="font-size:13px; color:#888;" v-if="item.mobile">{{ item.country_code }} {{ item.mobile }}</div>
                                </div>
                                <input v-if="visitModalType === 'to_meet'" type="checkbox"
                                    style="width:20px; height:20px; cursor:pointer; flex-shrink:0; margin-left:10px;"
                                    :checked="item.visited"
                                    @change="toggleVisit(item, $event.target.checked)" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Receipt Books allocated to this unit -->
    <div class="section mt-2 mb-1" v-if="is_youth_dawa_fund && receiptBooks.length">
        <div class="rb-header">
            <span class="mal-text rb-section-title">റെസിപ്റ്റ് ബുക്കുകൾ</span>
        </div>
        <div class="receipt-book-grid">
            <div class="receipt-book-card" v-for="book in receiptBooks" :key="book.id"
                :class="book.received ? 'received' : 'pending'">
                <!-- Row 1: icon + book info + status badge -->
                <div class="rb-row1">
                    <ion-icon name="book-outline" class="rb-icon"></ion-icon>
                    <div class="rb-info">
                        <span class="rb-title">Book {{ book.book_number }}</span>
                        <span class="rb-range" v-if="book.receipt_from">{{ book.receipt_from }} – {{ book.receipt_to }}</span>
                    </div>
                    <span v-if="book.received" class="rb-badge received-badge">
                        <ion-icon name="checkmark-circle-outline"></ion-icon> Received
                    </span>
                    <button v-else type="button" class="rb-receive-btn"
                        @click="markBookReceivedConfirmation(book)">
                        <ion-icon name="checkmark-outline"></ion-icon> Mark Received
                    </button>
                </div>
                <!-- Row 2: holder name with edit, or assign button if no holder (admin only) -->
                <div v-if="book.holder_name" class="rb-holder">
                    <ion-icon name="person-outline"></ion-icon>
                    <span style="flex:1;min-width:0;">{{ book.holder_name }}</span>
                    <button v-if="book.received && (permissions.update || book.holder_member_id == currentUser.member_id)" type="button"
                        class="rb-edit-holder-btn" @click="openChangeHolderModal(book)"
                        title="ചുമതലക്കാരനെ മാറ്റുക">
                        <ion-icon name="pencil-outline"></ion-icon>
                    </button>
                </div>
                <div v-else-if="permissions.update" class="rb-holder"
                    style="cursor:pointer;border:1px dashed #b0b8d0;border-radius:6px;background:#f5f7fc;"
                    @click="openChangeHolderModal(book)">
                    <ion-icon name="person-add-outline" style="color:#6b7fa3;font-size:16px;flex-shrink:0;"></ion-icon>
                    <span style="flex:1;color:#6b7fa3;font-size:13px;">ചുമതലക്കാരനെ ചേർക്കുക</span>
                </div>
            </div>
        </div>
    </div>
    <!-- Karad / FFR buttons — Youth Dawa Fund only -->
    <div class="section mt-1 mb-1" v-if="is_youth_dawa_fund">
        <div class="d-flex gap-2">
            <router-link
                :to="'/org/' + $route.params.sub_level + '/' + $route.params.id + '/fund-collection/' + $route.params.type + '/karad-list'"
                class="btn btn-sm btn-outline-primary flex-fill mal-text">
                കരട് ലിസ്റ്റ്
            </router-link>
            <button type="button" class="btn btn-sm btn-outline-secondary flex-fill" disabled>
                FFR List
            </button>
        </div>
    </div>
    <!-- Wallet Card -->
    <!-- <div class="section pt-2">
                                                                        <div class="wallet-card mt-1" v-if="currentUser.user_level <= 4">
                                                                            <div class="wallet-footer wallet-footer-user row">
                                                                                <div class="item col-12">
                                                                                    <a href="javascript:void(0)" @click="adminAdd">
                                                                                        <div class="icon-wrapper back-color-blue1">
                                                                                            <ion-icon name="add-outline"></ion-icon>
                                                                                            <strong class="menu-title mal-text">നേർപഥം ചേർക്കാൻ ഇവിടെ അമർത്തുക</strong>
                                                                                        </div>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> -->
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{unit.list_title}}</h3>
            <div class="mt-2 list-actions-row" v-if="listYear === currentYear || showDisableAddButton || showStatePaymentButton">
                <div class="list-actions-left" v-if="!is_youth_dawa_fund && listYear === currentYear">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="showOldList">പഴയ ലിസ്റ്റ്</button>
                </div>
                <div class="list-actions-left" v-else-if="!is_youth_dawa_fund">
                    <button type="button" class="btn btn-sm btn-outline-primary" @click="showCurrentList">നിലവിലെ ലിസ്റ്റ്</button>
                </div>
                <div class="list-actions-right" v-if="showDisableAddButton || showStatePaymentButton">
                    <button
                        v-if="showDisableAddButton"
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="disableAddConfirmation"
                    >
                        പുതിയ എൻട്രികൾ നിർത്തുക
                    </button>
                    <button
                        v-else-if="showStatePaymentButton"
                        type="button"
                        class="btn btn-sm btn-outline-success"
                        @click="payStateShare"
                    >
                        സ്റ്റേറ്റ് വിഹിതം അടയ്ക്കുക (₹{{ stateShareAmount.toFixed(2) }})
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Mark Book Received Modal -->
    <div class="modal fade action-sheet" id="receiveBookModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">റസീപ്റ്റ് ബുക്ക് സ്വീകരിക്കൽ</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">ബുക്ക് നമ്പർ</label>
                                <div style="font-size:16px;font-weight:800;color:#1a418c;padding:4px 0;">Book #{{ receiveBook_number }}</div>
                                <div v-if="receiveBook_from" style="font-size:13px;color:#64748b;margin-top:2px;">
                                    <ion-icon name="receipt-outline" style="vertical-align:middle;margin-right:3px;"></ion-icon>
                                    റസീപ്റ്റ്: <strong>{{ receiveBook_from }}</strong> – <strong>{{ receiveBook_to }}</strong>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label mal-text">ചുമതലക്കാരൻ</label>
                            <div v-if="receiveBook_selected"
                                style="display:flex;align-items:center;gap:8px;background:#eef3ff;border-radius:8px;padding:8px 12px;margin-bottom:6px;">
                                <div style="flex:1;">
                                    <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ receiveBook_selected.name }}</div>
                                    <div style="font-size:11px;color:#888;">{{ receiveBook_selected.mobile }}</div>
                                </div>
                                <button @click="receiveBook_selected = null; receiveBook_search = ''; receiveBook_holder = ''"
                                    style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0;">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <div v-else style="position:relative;">
                                <div style="display:flex;gap:6px;align-items:center;">
                                    <input v-model="receiveBook_search" @input="searchReceiveBookMember"
                                        class="form-control"
                                        placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                        style="flex:1;" />
                                    <div v-if="receiveBook_searching" style="padding:0 8px;">
                                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                                    </div>
                                </div>
                                <div v-if="receiveBook_results.length"
                                    style="border:1px solid #ddd;border-radius:8px;margin-top:4px;max-height:150px;overflow-y:auto;background:#fff;position:absolute;width:100%;z-index:999;">
                                    <div v-for="m in receiveBook_results" :key="m.id"
                                        @click="receiveBook_selected = m; receiveBook_holder = m.name; receiveBook_search = m.name; receiveBook_results = []"
                                        style="padding:8px 12px;border-bottom:1px solid #f0f0f0;cursor:pointer;">
                                        <div style="font-size:13px;font-weight:600;color:#27173E;">{{ m.name }}</div>
                                        <div style="font-size:11px;color:#888;">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" class="btn btn-success btn-block btn-lg mal-text"
                                :disabled="receiveBook_saving" @click="submitMarkBookReceived">
                                <span v-if="receiveBook_saving" class="spinner-border spinner-border-sm me-1"></span>
                                ലഭിച്ചതായി confirm ചെയ്യുക
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Change Holder Modal -->
    <div class="modal fade action-sheet" id="changeHolderModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">ചുമതലക്കാരനെ മാറ്റുക</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">ബുക്ക് നമ്പർ</label>
                                <div style="font-size:16px;font-weight:800;color:#1a418c;padding:4px 0;">Book #{{ changeHolder_number }}</div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div style="background:#fff7ed;border-left:3px solid #f59e0b;padding:8px 12px;border-radius:0 6px 6px 0;font-size:12px;color:#92400e;line-height:1.5;" class="mal-text">
                                ചുമതലക്കാരനെ മാറ്റിയാൽ ബുക്ക് വീണ്ടും <strong>"ലഭിക്കാത്തത്"</strong> ആകും. പുതിയ ചുമതലക്കാരൻ വീണ്ടും accept ചെയ്യണം.
                            </div>
                        </div>
                        <div class="form-group basic">
                            <label class="label mal-text">പുതിയ ചുമതലക്കാരൻ</label>
                            <div v-if="changeHolder_selected"
                                style="display:flex;align-items:center;gap:8px;background:#eef3ff;border-radius:8px;padding:8px 12px;margin-bottom:6px;">
                                <div style="flex:1;">
                                    <div style="font-size:13px;font-weight:700;color:#1a418c;">{{ changeHolder_selected.name }}</div>
                                    <div style="font-size:11px;color:#888;">{{ changeHolder_selected.mobile }}</div>
                                </div>
                                <button @click="changeHolder_selected = null; changeHolder_search = ''; changeHolder_name = ''"
                                    style="background:none;border:none;color:#aaa;font-size:18px;cursor:pointer;padding:0;">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <div v-else style="position:relative;">
                                <div style="display:flex;gap:6px;align-items:center;">
                                    <input v-model="changeHolder_search" @input="searchChangeHolderMember"
                                        class="form-control"
                                        placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                        style="flex:1;" />
                                    <div v-if="changeHolder_searching" style="padding:0 8px;">
                                        <div class="spinner-border spinner-border-sm text-secondary"></div>
                                    </div>
                                </div>
                                <div v-if="changeHolder_results.length"
                                    style="border:1px solid #ddd;border-radius:8px;margin-top:4px;max-height:150px;overflow-y:auto;background:#fff;position:absolute;width:100%;z-index:999;">
                                    <div v-for="m in changeHolder_results" :key="m.id"
                                        @click="changeHolder_selected = m; changeHolder_name = m.name; changeHolder_search = m.name; changeHolder_results = []"
                                        style="padding:8px 12px;border-bottom:1px solid #f0f0f0;cursor:pointer;">
                                        <div style="font-size:13px;font-weight:600;color:#27173E;">{{ m.name }}</div>
                                        <div style="font-size:11px;color:#888;">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <button type="button" class="btn btn-warning btn-block btn-lg mal-text"
                                style="color:#fff;"
                                :disabled="changeHolder_saving || !changeHolder_name" @click="submitChangeHolder">
                                <span v-if="changeHolder_saving" class="spinner-border spinner-border-sm me-1"></span>
                                ചുമതലക്കാരനെ മാറ്റുക
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- AddAdminModel -->
    <div class="modal fade action-sheet" id="addAdminModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!add_admin">Edit</h5>
                    <h5 class="modal-title" v-if="add_admin">Add New</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <Form @submit="addAdmin" :validation-schema="schema">
                            <!-- Office (QR) payment toggle — Youth Dawa Fund, new entries only -->
                            <div class="office-toggle" :class="{ active: officeMode }" v-if="is_youth_dawa_fund && add_admin">
                                <label class="office-toggle-row">
                                    <input type="checkbox" v-model="officeMode" />
                                    <span class="office-toggle-text">ഓഫീസ് പേയ്മെന്റ് (QR / ബാങ്ക്)</span>
                                    <ion-icon name="business-outline" class="office-toggle-icon"></ion-icon>
                                </label>
                                <small v-if="officeMode" class="office-toggle-note">
                                    പരിശോധനയ്ക്കായി ചേർക്കുന്നു · ഓഫീസ് വെരിഫൈ ചെയ്താൽ മാത്രമേ രസീത് (T) ജനറേറ്റ് ആകൂ.
                                </small>
                            </div>

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                    <select as="select" class="form-control custom-select" v-model="isMember" name="isMember" id="select4">
                                        <option value>---Select---</option>
                                        <option value="Y">അതെ</option>
                                        <option value="N">അല്ല</option>
                                    </select>
                                </div>
                                <input type="hidden" v-model="member_id" />
                            </div>
                            <div class="form-group basic typehead-div" v-if="isMember == 'Y'">
                                <div class="input-wrapper">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true" v-model="member" :value="member" :options="member_list" @input="getTextList($event.target.value, 0)">
                                        <template>
                                                                                        type to search...
</template>

<template>
    <div class="d-center">
        {{ member.name }}
    </div>
</template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                                <div class="input-info" v-if="member">Mobile :{{ member.country_code }} {{
                                        member.mobile
                                }}
                                </div>
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="input-wrapper">
                                    <label class="label" for="name"><span>Name</span></label>
                                    <Field name="name" type="text" class="form-control" v-model="name" :disabled="disable_member_form" placeholder="Name" autocomplete="off" />
                                </div>
                                <ErrorMessage name="name" class="error-feedback" />
                            </div>
                            <div class="form-group basic" v-if="isMember == 'N' || (edit_admin && isMember != 'Y')">
                                <div class="input-wrapper">
                                    <label class="label" for="mobile"><span>Mobile Number</span></label>
                                    <input type="tel" class="form-control" v-model="mobile" placeholder="Mobile Number" autocomplete="off" />
                                </div>
                            </div>

                            <!-- Office payment proof panel -->
                            <div class="office-panel" v-if="officeMode">
                                <div class="office-panel-title">
                                    <ion-icon name="receipt-outline"></ion-icon> പേയ്മെന്റ് തെളിവ്
                                </div>
                                <label class="upload-box" :class="{ filled: slipFileName }">
                                    <input type="file" accept="image/*,application/pdf" @change="onSlipChange" hidden />
                                    <ion-icon :name="slipFileName ? 'checkmark-circle' : 'cloud-upload-outline'" class="upload-icon"></ion-icon>
                                    <span v-if="!slipFileName" class="upload-text">
                                        സ്ലിപ്പ് / ഫോട്ടോ തിരഞ്ഞെടുക്കുക
                                        <small>image അല്ലെങ്കിൽ PDF</small>
                                    </span>
                                    <span v-else class="upload-text filled-text">
                                        {{ slipFileName }}
                                        <small>മാറ്റാൻ വീണ്ടും ടാപ്പ് ചെയ്യുക</small>
                                    </span>
                                </label>
                                <div class="office-or"><span>അല്ലെങ്കിൽ</span></div>
                                <div class="input-wrapper">
                                    <label class="label" for="transaction_id"><span>ട്രാൻസാക്ഷൻ ഐഡി <em>(optional)</em></span></label>
                                    <input type="text" class="form-control" v-model="transaction_id" placeholder="Transaction / UTR ID" autocomplete="off" />
                                </div>
                            </div>

                            <div class="form-group basic" v-if="!officeMode">
                                <div class="input-wrapper">
                                    <label class="label" for="receipt_no"><span>Receipt Number</span></label>
                                    <Field v-if="is_youth_dawa_fund" as="select" name="receipt_no"
                                        class="form-control custom-select" v-model="receipt_no">
                                        <option value="">---Select---</option>
                                        <option v-for="n in availableReceiptNumbers" :key="n" :value="n">{{ n }}</option>
                                    </Field>
                                    <Field v-else name="receipt_no" type="text" class="form-control" v-model="receipt_no" placeholder="Receipt Number" autocomplete="off" />
                                </div>
                                <ErrorMessage name="receipt_no" class="error-feedback" />
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="amount"><span>Amount (₹)</span></label>
                                    <Field name="amount" type="number" class="form-control" v-model="amount" placeholder="Amount" autocomplete="off" />
                                </div>
                                <ErrorMessage name="amount" class="error-feedback" />
                            </div>

                            <div class="form-group" v-if="message">
                                <div v-if="message" class="error-feedback">
                                    {{ message }}
                                </div>
                            </div>
    
                            <div class="form-group basic">
                                <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading" v-if="permissions.update">
                                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                        <span>Save</span></button>
                                <button type="button" class="btn btn-primary btn-block btn-lg" v-if="!permissions.update" @click="closeAddAdminModel">Close</button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- DeleteMemberModel -->
    
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="listed-detail mt-0">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && member_lists.total <= 0">ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>
    
    <ul class="listview image-listview inset text mt-2" v-if="!loading_list && member_lists.total > 0">
        <li v-for="(member_list, index) in member_lists.data" v-bind:key="member_list.id" :style="rowStyle(member_list)">
            <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ (member_lists.from + index) }}</span>
                                    <div class="avatar-section">
                                        <a href="#">
                                            <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                                            <!-- <span class="button verified" v-if="member_list.member.verified == 'Y'">
                                                <ion-icon name="checkmark-outline"></ion-icon>
                                            </span>
                                            <span class="button not-verified" v-if="member_list.member.verified == 'N' && member_list.member.verification_status">
                                                <ion-icon name="close-outline"></ion-icon>
                                            </span> -->
                                        </a>
            </div>
            <div class="in">
                <div class="min-width-50">
                    <!-- <header>User</header> -->
                    <b> {{ member_list.name }} </b>
                    <footer class="text-primary">{{ member_list.reciept_no }} | ₹{{ member_list.amount.toFixed(2) }}
                    </footer>
                    <footer v-if="is_youth_dawa_fund && member_list.source">
                        <span v-if="member_list.source === 'online'" class="badge bg-success" style="font-size:10px;">🌐 Online</span>
                        <span v-else-if="member_list.source === 'office' && member_list.office_status === 'pending'" class="badge bg-warning text-dark" style="font-size:10px;">⏳ Office (പരിശോധന ബാക്കി)</span>
                        <span v-else-if="member_list.source === 'office'" class="badge bg-success" style="font-size:10px;">✓ Office (ക്യാഷ് ലഭിച്ചു)</span>
                        <span v-else-if="member_list.source === 'karad'" class="badge bg-primary" style="font-size:10px;">കരട് ലിസ്റ്റ്</span>
                        <span v-else-if="member_list.source === 'ffr'" class="badge bg-info text-dark" style="font-size:10px;">FFR List</span>
                        <span v-else class="badge bg-secondary" style="font-size:10px;">Manual</span>
                    </footer>
                    <footer v-if="member_list.source === 'office' && member_list.office_status === 'pending' && member_list.transaction_id" style="font-size:11px;color:#b26a00;margin-top:2px;">
                        Txn: {{ member_list.transaction_id }}
                    </footer>
                    <footer v-if="member_list.source === 'online' && member_list.mobile" style="font-size:12px;color:#555;margin-top:2px;">
                        📞 {{ member_list.mobile }}
                    </footer>
                </div>
                <div class="card-button dropdown" v-if="listYear === currentYear">
                    <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal" :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                            </button>
                </div>
    
                <!-- Default Action Sheet Inset -->
                <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1" role="dialog">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ member_list.name }}</h5>
                            </div>
                            <div class="modal-body">
                                <ul class="action-button-list">
                                    <!-- Call button for online payments with mobile -->
                                    <li v-if="member_list.source === 'online' && member_list.mobile">
                                        <a :href="'tel:' + member_list.mobile" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="call-outline"></ion-icon> Call
                                            </span>
                                        </a>
                                    </li>
                                    <!-- WhatsApp button for online payments with mobile -->
                                    <li v-if="member_list.source === 'online' && member_list.mobile">
                                        <a href="javascript:void(0)" class="btn btn-list" data-bs-dismiss="modal"
                                            @click="openWhatsApp(member_list)">
                                            <span>
                                                <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" @click="adminView(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="pencil-outline"></ion-icon> Edit
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" @click="adminDeleteConfirmation(member_list)" class="btn btn-list" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="trash-outline"></ion-icon> Remove
                                            </span>
                                        </a>
                                    </li>
                                    <li class="action-divider"></li>
                                    <li>
                                        <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                            <span>
                                                <ion-icon name="close-outline"></ion-icon> Cancel
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- * Default Action Sheet Inset -->
            </div>
            </a>
        </li>
    </ul>
    <div class="section mt-2" v-if="!loading_list">
        <vue-awesome-paginate v-if="member_lists.total > 0" :total-items="member_lists.total" :items-per-page="member_lists.per_page" :max-pages-shown="3" v-model="member_lists.current_page" :on-click="getMembersList" :show-ending-buttons="true" :show-breakpoint-buttons="false"
        />
    </div>
    
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from 'jquery';
import vSelect from 'vue-select'
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
import HelpDeskCard from "../../components/HelpDeskCard.vue";
export default {
    name: 'Admin List',
    components: {
        Form,
        Field,
        vSelect,
        ErrorMessage,
        AlertModel,
        DialogModel,
        HelpDeskCard
    },
    props: {
        unit_id: null
    },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: "",
            officeMode: false,
            transaction_id: '',
            mobile: '',
            slipFile: null,
            slipFileName: '',
            member_lists: [],
            member_list: [],
            member: [],
            unit: [],
            editable_id: '',
            editable: false,
            permissions: [],
            add_admin: false,
            total: 0.00,
            target: 0.00,
            isMember: '',
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: [],
            member_edit: false,
            receipt_no: '',
            amount: '',
            isEdit: false,
            sub_level_name: '',
            district_eligible: false,
            zone_eligible: false,
            percentage:[],
            listYear: new Date().getFullYear(),
            receiptBooks: [],
            availableReceiptNumbers: [],
            is_youth_dawa_fund: false,
            breakdown: null,
            consOpen: false,
            receiveBook_id: null,
            receiveBook_number: '',
            receiveBook_from: '',
            receiveBook_to: '',
            receiveBook_holder: '',
            receiveBook_saving: false,
            receiveBook_search: '',
            receiveBook_selected: null,
            receiveBook_results: [],
            receiveBook_searching: false,
            receiveBook_timer: null,
            changeHolder_id: null,
            changeHolder_number: '',
            changeHolder_name: '',
            changeHolder_saving: false,
            changeHolder_search: '',
            changeHolder_selected: null,
            changeHolder_results: [],
            changeHolder_searching: false,
            changeHolder_timer: null,
            toMeetCount: 0,
            metCount: 0,
            toMeetList: [],
            metList: [],
            visitModalType: 'to_meet',
            visitModalList: [],
            fundCollection: {
                add_disabled: false,
                add_disabled_at: null,
                state_payment_started_at: null,
                state_payment_started_amount: null,
            }

        };
    },

    computed: {
        schema() {
            if (this.officeMode) {
                return yup.object().shape({
                    amount: yup.string().required("ഫിൽ ചെയ്യുക!"),
                });
            }
            return yup.object().shape({
                receipt_no: yup.string().required("ഫിൽ ചെയ്യുക!"),
                amount: yup.string().required("ഫിൽ ചെയ്യുക!"),
            });
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        currentYear() {
            return new Date().getFullYear();
        },
        isUnitLevelPage() {
            return parseInt(this.user_level) === 4;
        },
        isTargetAchieved() {
            return (this.target ?? 0) > 0 && (this.total ?? 0) >= (this.target ?? 0);
        },
        hasReceivedBook() {
            return this.receiptBooks.some((b) => b.received);
        },
        showAddButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            if (this.fundCollection?.add_disabled) return false;
            // Youth Dawa Fund: only allow adding once at least one receipt book is received
            if (this.is_youth_dawa_fund && !this.hasReceivedBook) return false;
            return true;
        },
        showDisableAddButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            if (!this.isUnitLevelPage) return false;
            if (!this.isTargetAchieved) return false;
            return !(this.fundCollection?.add_disabled);
        },
        showStatePaymentButton() {
            if (!(this.permissions.update && this.listYear === this.currentYear)) return false;
            if (!this.isUnitLevelPage) return false;
            if (!(this.fundCollection?.add_disabled)) return false;
            // Only show payment button when there is some state share amount
            return this.stateShareAmount > 0;
        },
        stateShareAmount() {
            const val = this.getPercentage(this.target ? this.target : 0, this.total, 1);
            const parsed = parseFloat(val);
            return Number.isFinite(parsed) ? parsed : 0;
        },
        minusToZero() {
            let value = this.target - this.total;
            if (value <= 0) {
                return '0';
            } else {
                return value.toFixed(2);
            }
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            this.getMembersList(1);
            this.$root.updateParent('Loading...');
        }
        // this.getComboboxValues('COUNTRY_CODE');
        window.onpopstate = function() {
            if ($('body').hasClass('modal-open')) {
                location.reload();
            }
        };
    },
    methods: {
        // Distribution: 100%+ target → Unit 15%, Zone 10%, District 10%, State 65%; 75–99% → State 85%, 5% each; <75% → 100% state
        getPercentage(target, total, type) {
            // If API overrides all percentages to 0 (e.g. Youth Dawa Fund), return 0
            if (this.percentage && this.percentage.state_75 === 0 && this.percentage.district_75 === 0 &&
                this.percentage.zone_75 === 0 && this.percentage.unit_75 === 0) {
                return (0).toFixed(2);
            }
            const threshold75 = target ? (target * 75) / 100 : 0;
            const reached100 = target && total >= target;
            const reached75 = total >= threshold75;
            let pct;
            if (reached100) {
                if (type == 1) pct = 65;
                else if (type == 2) pct = 10;
                else if (type == 3) pct = 10;
                else if (type == 4) pct = 15;
            } else if (reached75) {
                if (type == 1) pct = this.percentage.state_75 ?? 85;
                else if (type == 2) pct = this.percentage.district_75 ?? 5;
                else if (type == 3) pct = this.percentage.zone_75 ?? 5;
                else if (type == 4) pct = this.percentage.unit_75 ?? 5;
            } else {
                if (type == 1) pct = 100;
                else pct = 0;
            }
            return ((total / 100) * (pct ?? 0)).toFixed(2);
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id
            }
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case 'COUNTRY_CODE':
                            this.country_code_list = response.data.data.list.options;
                            break;
                        case 'UNVERIFIED_REASON':
                            this.verification_status_list = response.data.data.list.options;
                            break;

                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminView(admin) {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.isEdit = true;
            this.officeMode = false;
            this.transaction_id = '';
            this.mobile = admin.mobile || '';
            this.slipFile = null;
            this.slipFileName = '';
            if (admin.member_id) {
                this.member_id = admin.member_id;
                this.disable_member_form = true;
            } else {
                this.disable_member_form = false;
            }
            this.name = admin.name;
            this.amount = admin.amount;
            this.receipt_no = admin.reciept_no;
            this.member_edit = false;
            this.member_list.push(this.member);
            this.editable_id = admin.id;
            this.add_admin = false;
            this.edit_admin = true;
            this.loadAvailableReceiptNumbers(admin.reciept_no);
        },
        adminAdd() {
            $('#addAdminModel').modal('show');
            this.message = '';
            this.disable_member_form = false;
            this.name = '';
            this.receipt_no = '';
            this.member_edit = true;
            this.amount = '';
            this.editable_id = null;
            this.add_admin = true;
            this.edit_admin = false;
            this.officeMode = false;
            this.transaction_id = '';
            this.mobile = '';
            this.slipFile = null;
            this.slipFileName = '';
            this.loadAvailableReceiptNumbers();
        },
        onSlipChange(e) {
            const file = e.target.files && e.target.files[0];
            this.slipFile = file || null;
            this.slipFileName = file ? file.name : '';
        },
        formatAmt(v) {
            const n = parseFloat(v || 0);
            return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        closeAddAdminModel() {
            $('#addAdminModel').modal('hide');
        },
        addAdmin(user) {
            this.loading = true;
            user.editable_id = this.editable_id;
            user.unit_id = parseInt(this.$route.params.id);
            user.fund_type = this.$route.params.type;
            user.is_member = this.isMember;
            user.is_office = this.officeMode;
            user.transaction_id = this.officeMode ? this.transaction_id : null;
            // Mobile: from the selected member, else the typed number
            user.mobile = (this.isMember == 'Y' && this.member && this.member.mobile) ? this.member.mobile : this.mobile;
            if (this.isMember == 'Y') {
                if (this.member) {
                    if (this.member.length == 0) {
                        this.alert_type = 'Warning';
                        this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                        return false;
                    }
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്തതിനു ശേഷം Save അമർത്തുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }

            }
            if (this.isMember == 'N' && !user.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            if (this.isMember == 'Y') {
                user.member_id = this.member.id;
            } else {
                user.member_id = null;
            }
            // Office mode: require a slip upload OR a transaction id
            if (this.officeMode && !this.slipFile && !(this.transaction_id && this.transaction_id.trim())) {
                this.alert_type = 'Warning';
                this.alert_message = 'പേയ്മെന്റ് സ്ലിപ്പ് അപ്‌ലോഡ് ചെയ്യുക അല്ലെങ്കിൽ ട്രാൻസാക്ഷൻ ഐഡി നൽകുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return false;
            }
            let savePromise;
            if (this.officeMode) {
                const fd = new FormData();
                Object.keys(user).forEach((k) => {
                    if (user[k] !== null && user[k] !== undefined) fd.append(k, user[k]);
                });
                if (this.slipFile) fd.append('slip', this.slipFile);
                savePromise = UserService.authPostRequest('store-fund-collections', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
            } else {
                savePromise = UserService.addAdmin('store-fund-collections', user);
            }
            savePromise.then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#addAdminModel').modal('hide')
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        adminDeleteConfirmation(admin_list) {
            var data = {
                id: admin_list.id,
            }
            this.dialog_action_params = data;
            this.dialog_message = 'ശരിക്കും ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'adminDelete';
            this.$refs.dialog_model.openModel();
            this.loading = false;
        },
        rowStyle(item) {
            if (item.source === 'office' && item.office_status === 'pending') {
                return { 'background-color': '#fff3e0' }; // orange tint — unverified office
            }
            if (item.source === 'office' && item.office_status === 'verified') {
                return { 'background-color': '#e8f5e9' }; // green tint — verified (cash received)
            }
            return {};
        },
        adminDelete(data) {
            UserService.authPostRequest('delate-fund-collections', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1, 6);
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        loadVisitCounts() {
            if (!this.is_youth_dawa_fund) return;
            UserService.authPostRequest('get-visit-counts', {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.listYear,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.toMeetCount = response.data.data.to_meet_count;
                    this.metCount = response.data.data.met_count;
                    this.toMeetList = response.data.data.to_meet_list;
                    this.metList = response.data.data.met_list;
                }
            });
        },
        openVisitModal(type) {
            this.visitModalType = type;
            this.visitModalList = type === 'to_meet' ? this.toMeetList : this.metList;
            $('#visitCountsModal').modal('show');
        },
        toggleVisit(item, checked) {
            item.visited = checked;
            // Update counts reactively
            this.metCount = this.toMeetList.filter(i => i.visited).length;
            this.metList = this.toMeetList.filter(i => i.visited);

            const data = {
                unit_id: parseInt(this.$route.params.id),
                fund_type: parseInt(this.$route.params.type),
                year: this.listYear,
                source: item.source,
                visited: checked,
            };
            if (item.source === 'karad') {
                data.pledge_id = item.pledge_id;
            } else {
                data.member_id = item.member_id;
                data.name = item.name;
            }
            UserService.authPostRequest('toggle-visit', data);
        },
        loadReceiptBooks(redirectIfEmpty = false) {
            if (!this.is_youth_dawa_fund) {
                this.receiptBooks = [];
                return;
            }
            UserService.authPostRequest('receipt-book/list', {
                fund_type: parseInt(this.$route.params.type),
                level: 4,
                id: parseInt(this.$route.params.id),
            }).then((response) => {
                if (response.data.status === 'success') {
                    let books = response.data.data.books || [];
                    // Only regular members (user_level >= 5) get filtered to their own assigned book.
                    // Admins (levels 1–4) always see all books on the unit page.
                    if (parseInt(this.currentUser.user_level) >= 5) {
                        const myMemberId = this.currentUser.member_id;
                        if (myMemberId) {
                            books = books.filter(b => b.holder_member_id == myMemberId);
                        }
                        // On initial page load, redirect back if no book is assigned to this member
                        if (!books.length && redirectIfEmpty) {
                            this.$router.replace('/org');
                            return;
                        }
                    }
                    this.receiptBooks = books;
                }
            });
        },
        loadAvailableReceiptNumbers(currentNo = null) {
            if (!this.is_youth_dawa_fund) {
                this.availableReceiptNumbers = [];
                return;
            }
            const data = {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            };
            if (currentNo) {
                data.current_receipt_no = currentNo;
            }
            UserService.authPostRequest('receipt-book/available-receipt-numbers', data).then((response) => {
                if (response.data.status === 'success') {
                    this.availableReceiptNumbers = response.data.data.numbers || [];
                }
            });
        },
        markBookReceivedConfirmation(book) {
            this.receiveBook_id = book.id;
            this.receiveBook_number = book.book_number;
            this.receiveBook_from = book.receipt_from || '';
            this.receiveBook_to = book.receipt_to || '';
            this.receiveBook_holder = book.holder_name || '';
            this.receiveBook_member_id = book.holder_member_id || null;
            this.receiveBook_search = '';
            this.receiveBook_selected = book.holder_name ? { name: book.holder_name, mobile: '' } : null;
            this.receiveBook_results = [];
            $('#receiveBookModal').modal('show');
        },
        searchReceiveBookMember() {
            clearTimeout(this.receiveBook_timer);
            if (!this.receiveBook_search || this.receiveBook_search.length < 2) {
                this.receiveBook_results = [];
                return;
            }
            this.receiveBook_searching = true;
            this.receiveBook_timer = setTimeout(() => {
                UserService.authGetRequest('members/search', {
                    search: this.receiveBook_search,
                    unit_id: parseInt(this.$route.params.id),
                }).then((response) => {
                    this.receiveBook_searching = false;
                    this.receiveBook_results = response.data.data?.list || [];
                }).catch(() => { this.receiveBook_searching = false; });
            }, 400);
        },
        submitMarkBookReceived() {
            if (this.receiveBook_saving) return;
            this.receiveBook_saving = true;
            UserService.authPostRequest('receipt-book/mark-received', {
                id: this.receiveBook_id,
                holder_name: this.receiveBook_holder || undefined,
                holder_member_id: this.receiveBook_selected?.id || this.receiveBook_member_id || undefined,
            }).then(
                (response) => {
                    this.receiveBook_saving = false;
                    $('#receiveBookModal').modal('hide');
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loadReceiptBooks();
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.receiveBook_saving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        openChangeHolderModal(book) {
            this.changeHolder_id = book.id;
            this.changeHolder_number = book.book_number;
            this.changeHolder_name = book.holder_name || '';
            this.changeHolder_search = '';
            this.changeHolder_selected = book.holder_name ? { name: book.holder_name, mobile: '' } : null;
            this.changeHolder_results = [];
            $('#changeHolderModal').modal('show');
        },
        searchChangeHolderMember() {
            clearTimeout(this.changeHolder_timer);
            if (!this.changeHolder_search || this.changeHolder_search.length < 2) {
                this.changeHolder_results = [];
                return;
            }
            this.changeHolder_searching = true;
            this.changeHolder_timer = setTimeout(() => {
                UserService.authGetRequest('members/search', {
                    search: this.changeHolder_search,
                    unit_id: parseInt(this.$route.params.id),
                }).then((response) => {
                    this.changeHolder_searching = false;
                    this.changeHolder_results = response.data.data?.list || [];
                }).catch(() => { this.changeHolder_searching = false; });
            }, 400);
        },
        submitChangeHolder() {
            if (this.changeHolder_saving || !this.changeHolder_name) return;
            this.changeHolder_saving = true;
            UserService.authPostRequest('receipt-book/update', {
                id: this.changeHolder_id,
                holder_name: this.changeHolder_name,
                holder_member_id: this.changeHolder_selected?.id || undefined,
            }).then(
                (response) => {
                    this.changeHolder_saving = false;
                    $('#changeHolderModal').modal('hide');
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = 'ചുമതലക്കാരനെ മാറ്റി. ബുക്ക് വീണ്ടും accept ചെയ്യണം.';
                        this.$refs.alert_model.openModel();
                        this.loadReceiptBooks();
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.changeHolder_saving = false;
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        showOldList() {
            this.listYear = this.currentYear - 1;
            this.getMembersList(1);
        },
        showCurrentList() {
            this.listYear = this.currentYear;
            this.getMembersList(1);
        },
        getMembersList(page = 1) {
            this.loading_list = true;
            let data = {
                user_level: this.user_level,
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.listYear
            }
            UserService.authPostRequest(`get-fund-collections?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.permissions = response.data.data.permissions;
                        this.district_eligible = response.data.data.district_eligible;
                        this.zone_eligible = response.data.data.zone_eligible;
                        this.percentage = response.data.data.percentage;
                        this.is_youth_dawa_fund = response.data.data.is_youth_dawa_fund ?? false;
                        this.member_lists = response.data.data.list;
                        this.total = response.data.data.total;
                        this.target = response.data.data.target;
                        this.breakdown = response.data.data.breakdown ?? null;
                        this.fundCollection = response.data.data.fund_collection ?? this.fundCollection;
                        this.search_qty = '';
                        this.orgnal_member_lists = response.data.data.list.data;
                        this.unit = response.data.data.unit;
                        if (response.data.data.year != null) {
                            this.listYear = response.data.data.year;
                        }
                        this.$root.updateParent(this.unit.page_title);
                        this.loadReceiptBooks(true);
                        this.loadVisitCounts();
                        this.loading_list = false;
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        disableAddConfirmation() {
            const data = {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.currentYear,
            };
            this.dialog_action_params = data;
            this.dialog_message = 'Target achieved. ഇനി Add ഓഫ് ചെയ്യണോ?';
            this.dialog_action = 'disableAdd';
            this.$refs.dialog_model.openModel();
        },
        disableAdd(data) {
            UserService.authPostRequest('set-fund-collection-add-disabled', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = 'Add button disabled.';
                        this.$refs.alert_model.openModel();
                        this.getMembersList(1);
                    } else {
                        this.alert_type = response.data.status === 'warning' ? 'Warning' : 'Error';
                        this.alert_message = response.data.message || 'Failed.';
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.alert_type = 'Error';
                    this.alert_message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                    this.$refs.alert_model.openModel();
                }
            );
        },
        openWhatsApp(item) {
            const mobile = (item.mobile || '').replace(/\D/g, '');
            if (!mobile) return;
            const number = mobile.startsWith('91') ? mobile : '91' + mobile;
            const msg = encodeURIComponent(
                'സലാം ' + (item.name || '') + ',\n\n' +
                'വിസ്‌ഡം യൂത്ത് ദഅ്‌വ ഫണ്ടിലേക്ക് ₹' + (item.amount || '') + ' ഓൺലൈൻ ആയി അടച്ചതിന് നന്ദി.\n' +
                'Receipt: ' + (item.reciept_no || '') + '\n\n' +
                'ജസകല്ലാഹ് ഖൈർ 🙏'
            );
            setTimeout(() => window.open('https://wa.me/' + number + '?text=' + msg, '_blank'), 300);
        },
        payStateShare() {
            const amount = this.stateShareAmount;
            if (!amount || amount <= 0) {
                this.alert_type = 'Warning';
                this.alert_message = 'Invalid amount.';
                this.$refs.alert_model.openModel();
                return;
            }
            const data = {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                year: this.currentYear,
                amount: amount,
            };
            UserService.authPostRequest('mark-fund-collection-state-payment-started', data).finally(() => {
                const url = new URL('https://www.donate.wisdomislam.org/working-fund');
                url.searchParams.set('amount', amount.toFixed(2));
                url.searchParams.set('note', 'സ്റ്റേറ്റ് വിഹിതം');
                url.searchParams.set('unit_id', String(this.$route.params.id));
                window.open(url.toString(), '_blank');
                this.getMembersList(1);
            });
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

/* ── Help Desk card ───────────────────────────────────────────── */
.helpdesk-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 8px 12px;
    box-shadow: 0 2px 10px rgba(0,0,0,.04);
}
.helpdesk-left { display: flex; align-items: center; gap: 7px; min-width: 0; }
.helpdesk-icon { font-size: 20px; color: #1a418c; flex-shrink: 0; }
.helpdesk-title { font-size: 13px; font-weight: 800; color: #27173E; white-space: nowrap; }
.helpdesk-actions { display: flex; gap: 7px; }
.helpdesk-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    color: #fff;
    text-decoration: none;
}
.helpdesk-btn ion-icon { font-size: 18px; }
.helpdesk-btn.call { background: #1a418c; }
.helpdesk-btn.wa { background: #25D366; }

/* ── Collection consolidation card ─────────────────────────────── */
.consolidation-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 14px;
    padding: 4px 16px;
    box-shadow: 0 2px 10px rgba(0,0,0,.04);
}
.cons-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 0;
    cursor: pointer;
    user-select: none;
}
.cons-title {
    font-size: 13px;
    font-weight: 800;
    color: #27173E;
    letter-spacing: 0.02em;
}
.cons-chevron {
    font-size: 18px;
    color: #94a3b8;
    transition: transform .28s ease;
}
.cons-chevron.open {
    transform: rotate(180deg);
}
.cons-body {
    padding-bottom: 8px;
}
/* collapse transition */
.cons-collapse-enter-active,
.cons-collapse-leave-active {
    transition: max-height .28s ease, opacity .28s ease;
    overflow: hidden;
}
.cons-collapse-enter-from,
.cons-collapse-leave-to {
    max-height: 0;
    opacity: 0;
}
.cons-collapse-enter-to,
.cons-collapse-leave-from {
    max-height: 240px;
    opacity: 1;
}
.cons-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 9px 0;
    border-top: 1px solid #f3f4f8;
}
.cons-row:first-of-type { border-top: none; }
.cons-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: #475569;
    font-weight: 600;
}
.cons-label ion-icon { font-size: 18px; }
.cons-val {
    font-size: 15px;
    font-weight: 800;
    color: #27173E;
}

/* ── Office payment form ───────────────────────────────────────── */
.office-toggle {
    border: 1.5px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px 14px;
    margin-bottom: 16px;
    background: #f8fafc;
    transition: all .2s ease;
}
.office-toggle.active {
    border-color: #f59e0b;
    background: #fff8ef;
}
.office-toggle-row {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    margin: 0;
}
.office-toggle-row input[type="checkbox"] {
    width: 20px;
    height: 20px;
    accent-color: #f59e0b;
    flex-shrink: 0;
}
.office-toggle-text {
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
    flex: 1;
}
.office-toggle-icon {
    font-size: 22px;
    color: #f59e0b;
}
.office-toggle-note {
    display: block;
    margin-top: 8px;
    font-size: 11.5px;
    line-height: 1.5;
    color: #92400e;
}

.office-panel {
    border: 1.5px dashed #fbbf24;
    background: #fffbf3;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 16px;
}
.office-panel-title {
    font-weight: 700;
    font-size: 13px;
    color: #b45309;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 100%;
    min-height: 92px;
    padding: 14px;
    border: 2px dashed #cbd5e1;
    border-radius: 10px;
    background: #fff;
    cursor: pointer;
    text-align: center;
    transition: all .2s ease;
}
.upload-box:hover { border-color: #f59e0b; background: #fffaf0; }
.upload-box.filled { border-color: #16a34a; border-style: solid; background: #f0fdf4; }
.upload-icon { font-size: 30px; color: #94a3b8; }
.upload-box.filled .upload-icon { color: #16a34a; }
.upload-text {
    font-size: 13px;
    font-weight: 600;
    color: #475569;
    line-height: 1.4;
}
.upload-text small {
    display: block;
    font-weight: 400;
    font-size: 11px;
    color: #94a3b8;
    margin-top: 2px;
}
.upload-text.filled-text { color: #15803d; word-break: break-all; }
.upload-text.filled-text small { color: #4ade80; }

.office-or {
    text-align: center;
    margin: 12px 0;
    position: relative;
}
.office-or::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #fde0a8;
}
.office-or span {
    position: relative;
    background: #fffbf3;
    padding: 0 12px;
    font-size: 11px;
    color: #b45309;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.office-panel .input-wrapper .label em {
    font-style: normal;
    color: #94a3b8;
    font-weight: 400;
}

.error-feedback {
    color: red;
}

.listview {
    margin-bottom: 0;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    /* font-size: 28px; */
    margin-bottom: 14px;
    padding-left: 10px;
}

.wallet-card {
    padding-bottom: 0px !important;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .title {
    color: #27173E;
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}

.list-actions-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}

.list-actions-left,
.list-actions-right {
    display: flex;
    align-items: center;
}

.list-actions-right .btn {
    white-space: nowrap;
}

.stat-box {
    background: #ffffff;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 9%);
    border-radius: 10px;
    padding: 10px 10px;
}

.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db;
    border: 1px solid #3498db;
    color: white;
}

.active-page:hover {
    background-color: #2988c8;
}

/* Receipt Book Cards */
.receipt-book-grid {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.receipt-book-card {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.07);
    border-left: 3px solid #ccc;
}

.receipt-book-card.received {
    border-left-color: #22c55e;
    background: #f0fdf4;
}

.receipt-book-card.pending {
    border-left-color: #f59e0b;
    background: #fffbeb;
}

/* Row 1: icon + title/range + status button */
.rb-row1 {
    display: flex;
    align-items: center;
    gap: 8px;
}

.rb-icon {
    font-size: 20px;
    color: #1a418c;
    flex-shrink: 0;
}

.rb-info {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex: 1;
    min-width: 0;
}

.rb-title {
    font-weight: 700;
    font-size: 14px;
    color: #1e293b;
    white-space: nowrap;
}

.rb-range {
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
}

/* Row 2: holder pill — full width */
.rb-holder {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #1a418c;
    background: #eef3ff;
    border: 1px solid #d0dbff;
    border-radius: 8px;
    padding: 5px 12px;
}

.rb-holder ion-icon {
    font-size: 14px;
    flex-shrink: 0;
}

.rb-badge.received-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #22c55e;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 9px;
    border-radius: 20px;
}

.rb-badge.received-badge ion-icon {
    font-size: 12px;
}

.rb-receive-btn {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #1a418c;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 20px;
    border: none;
    cursor: pointer;
    white-space: nowrap;
}

.rb-receive-btn ion-icon {
    font-size: 12px;
}

.rb-receive-btn:active {
    background: #122d61;
}

.rb-edit-holder-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #a5b4fc;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    padding: 0;
    cursor: pointer;
    color: #4f46e5;
    flex-shrink: 0;
    margin-left: auto;
}

.rb-edit-holder-btn ion-icon {
    font-size: 13px;
}

.rb-edit-holder-btn:active {
    background: #e0e7ff;
}

.rb-header {
    margin-bottom: 6px;
}

.rb-section-title {
    font-size: 13px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.04em;
}
</style>